<template>
  <v-card class="elevation-10">
      <v-card-title>
          <v-container grid-list-md text-xs-center>
              <v-layout row wrap>

                <!-- sample -->
                <v-flex xs3>
                    <v-autocomplete
                            :items="samples_to_select"
                            item-text="name"
                            label="Sample"
                            item-value="id"
                            v-model="sample_id"
                            clearable
                    ></v-autocomplete>
                </v-flex>

                <!-- sample request -->
                <v-flex xs3>
                    <v-autocomplete
                            :items="sample_orders_to_select"
                            item-text="name"
                            label="Sample order"
                            item-value="id"
                            v-model="sample_order_id"
                            clearable
                    ></v-autocomplete>
                </v-flex>


                <!-- client -->
                <v-flex xs3>
                    <v-autocomplete
                            v-model="cliente_id"
                            :items="clients"
                            label="Client"
                            item-text="company_name"
                            item-value="id"
                            clearable
                    >
                    </v-autocomplete>
                </v-flex>

              </v-layout>
              <v-layout row wrap>
                <!-- from -->
                <v-flex md2 xs2>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu_from"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                            v-validate="''"
                            slot="activator"
                            v-model="from"
                            label="From"
                            data-vv-name="from"
                            readonly
                            browser-autocomplete="off"
                            clearable
                    ></v-text-field>
                    <v-date-picker v-model="from" @input="fromOnChange"></v-date-picker>
                  </v-menu>
                </v-flex>

                  <!-- to -->
                <v-flex md2 xs2>
                  <v-menu
                  :close-on-content-click="false"
                  v-model="menu_to"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <v-text-field
                          v-validate="''"
                          slot="activator"
                          v-model="to"
                          data-vv-name="to"
                          label="To"
                          readonly
                          browser-autocomplete="off"
                            clearable
                  ></v-text-field>
                  <v-date-picker v-model="to" @input="toOnChange"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-end>

                <!-- search -->
                <v-flex xs4>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                    ></v-text-field>
                </v-flex>

                <!-- per page -->
                <v-flex xs1 sm1 d-flex>
                  <v-select
                    :items="[10, 15, 25, 35, 50 ,60]"
                    label="Per page"
                    v-model="per_page"
                    @change="getSamples"
                  ></v-select>
                </v-flex>

                <!-- export -->
                <v-flex xs2>
                  <v-btn :href="BASE + 'samples/orders/export?client_id=' + cliente_id
                                                      + '&search=' + search
                                                      + '&sortBy=' + sortBy
                                                      + '&order=' + order
                                                      + '&download_token=' + download_token
                                                      + '&sample_order_id=' + sample_order_id
                                                      + '&sample_id=' + sample_id
                                                      + '&from=' + from
                                                      + '&to=' + to
                          " target="_blank"
                >Export</v-btn>
                </v-flex>
              </v-layout>
          </v-container>
      </v-card-title>
      <v-data-table
              :headers="headers"
              :items="samples.data"
              :search="search"
              :pagination.sync="pagination"
              hide-actions
              :loading="loading"
              :total-items="8"
              v-on:update:pagination="ordenar"
      >
          <template slot="items" slot-scope="props">
              <tr>

                  <td >{{ props.item.sample.name }}</td>
                  <td @click="ver(props.item.sample_request.id, true)" @contextmenu.prevent="ver(props.item.sample_request.id, true)" class="text-xs">
                    <span style="text-decoration: underline; cursor: pointer">{{ props.item.sample_request ? props.item.sample_request.request_ : 'NA' }}</span>
                  </td>
                  <td class="text-xs">{{ props.item.client ? props.item.client.company_name : 'NA' }}</td>
                  <td class="text-xs">{{ props.item.date }}</td>

              </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
          </v-alert>
      </v-data-table>
      <div class="text-xs-center pt-4 pb-4" v-if="samples.data">
          <v-pagination
                  v-model="page"
                  :length="last_page"
                  color="secondary"
                  circle
                  :total-visible="7"
                  @input="setPage"
          ></v-pagination>
          <p class="subtitle">Showing {{ samples.meta.from }} to {{ samples.meta.to }} of {{ samples.meta.total }} entries</p>
      </div>
  </v-card>
</template>

<script>
import { BASE } from '../../../config.js';

export default {
  data () {
      return {
          search: '',
          page: null,
          last_page: null,
          pagination: {sortBy: 'date', descending: true },
          loading: false,
          headers: [
              { text: 'Sample', align: 'left', sortable: true, value : 'sample' },
              { text: 'Sample request', sortable: true, value : 'sample_request' },
              { text: 'Client',  sortable: true, value : 'client' },
              { text: 'Date', sortable: true, value : 'date' }
          ],
          samples: [],
          sample_orders_to_select : [],
          direction: 'left',
          fab: [],
          fling: false,
          hover: false,
          tabs: null,
          top: false,
          right: true,
          bottom: true,
          left: false,
          transition: 'slide-x-transition',
          clients: null,
          cliente_id: null,
          sample_order_id : null,
          BASE: BASE,
          sortBy: 'date',
          order: 'desc',
          per_page: 25,

          download_token: null,
          menu_from : false,
          from : null,
          menu_to : false,
          to : null,
          samples_to_select : [],
          sample_id : null
      }
  },
  created: function() {
      this.checkUser();
      this.setSectionTitle();
      this.getClients();
      this.setQueryParams();
      this.getSamples();
      this.getSamplesToSelect();
      this.getSampleOrderToSelect();
      this.debouncedGetSamples = _.debounce(this.getSamples, 500)
  },
  watch: {
      search: function () {
          this.loading = true;
          this.page = 1;
          this.$router.push({ query: Object.assign({}, this.$route.query, { search: this.search }) });
          this.debouncedGetSamples();
      },
      last_page: function () {
          if (this.page > this.samples.meta.last_page) {
              this.page = 1;
          }
      },
      cliente_id: function () {
          if (this.cliente_id == undefined) {
              this.cliente_id = null;
          }

          this.$router.push({ query: Object.assign({}, this.$route.query, { cliente_id: this.cliente_id }) });

          this.page = 1;
          this.debouncedGetSamples();
      },

      sample_order_id: function () {
          if (this.sample_order_id == undefined) {
              this.sample_order_id = null;
          }

          this.$router.push({ query: Object.assign({}, this.$route.query, { sample_order_id: this.sample_order_id }) });

          this.page = 1;
          this.debouncedGetSamples();
      },

      to : function(){
        if(this.to == undefined){
          this.to = null;
        }

        this.page = 1;
        this.$router.push({ query: Object.assign({}, this.$route.query, { to: this.to }) });
        this.debouncedGetSamples();

      },

      from : function(){
        if(this.from == undefined){
          this.from = null;
        }

        this.page = 1;
        this.$router.push({ query: Object.assign({}, this.$route.query, { from: this.from }) });
        this.debouncedGetSamples();

      },

      sample_id : function(){
        if(this.sample_id == undefined){
          this.sample_id = null;
        }

        this.page = 1;
        this.$router.push({ query: Object.assign({}, this.$route.query, { sample_id: this.sample_id }) });
        this.debouncedGetSamples();
      },

      page: function () {
          this.$router.push({ query: Object.assign({}, this.$route.query, { page: this.page }) });
      },
  },
  methods : {
      setQueryParams() {
          if (this.$route.query.search) {
              this.search = this.$route.query.search;
          }
          if (this.$route.query.cliente_id) {
              this.cliente_id = parseInt(this.$route.query.cliente_id);
          }

          if (this.$route.query.page) {
              this.page = parseInt(this.$route.query.page);
          }

          if (this.$route.query.sample_order_id) {
              this.sample_order_id = parseInt(this.$route.query.sample_order_id);
          }

          if(this.$route.query.to){
            this.to = this.$route.query.to;
          }

          if(this.$route.query.from){
            this.from = this.$route.query.from;
          }
      },
      checkUser() {
          this.$store.dispatch('checkAccessToken').then((res) => {
              this.download_token = this.$store.getters.getUser.download_token;
          }).catch((error) => {

          });
      },
      ver(id, blank) {
          if (blank) {
              let route = this.$router.resolve({ name: 'admin.samples.detail', params : { id : id } });
              window.open(route.href, '_blank');
          } else {
              this.$router.push({ name: 'admin.samples.detail', params : { id : id } });
          }

      },

      getSamplesToSelect () {

          this.$store.dispatch('samplesToSelect', { search : null }).then((res) => {
              this.samples_to_select = res.data.data;
          }).catch((error) => {
            console.log(error);
          });
      },

      getSampleOrderToSelect() {
        this.$store.dispatch('getSampleOrdersToSelect', { search : null }).then((res) => {
            this.sample_orders_to_select = res.data.data;
        }).catch((error) => {
          console.log(error);
        });
      },

      ordenar (payload) {
          this.loading = true;
          this.sortBy = payload.sortBy;
          if (payload.descending) {
              this.order = 'desc';
          } else {
              this.order = 'asc';
          }
          this.getSamples();
      },
      setSectionTitle () {
          this.$store.dispatch('setSectionTitle', {
              title: 'Samples list.'
          });
      },

      getClients () {
          this.$store.dispatch('getClientsSelect').then((res) => {
              this.clients = res.data;
          }).catch((error) => {

          });
      },


      setPage (page) {
          this.page = page;
          this.getSamples();
      },

      toOnChange () {
        this.menu_to = false;
        //this.getSamples();
      },

      fromOnChange () {
        this.menu_from = false;
        //this.getSamples();
      },

      getSamples () {
          var params = {
              filters : {
                  search: this.search,
                  page: this.page,
                  client_id: this.cliente_id,
                  sortBy: this.sortBy,
                  order: this.order,
                  per_page: this.per_page,
                  to : this.to,
                  from : this.from,
                  sample_id : this.sample_id,
                  sample_order_id : this.sample_order_id
              }
          };

          this.$store.dispatch('getSampleOrderLines2', params).then((res) => {

              this.samples = res.data;
              this.page = res.data.meta.current_page;
              this.last_page = res.data.meta.last_page;
              this.loading = false;

              this.fab = [];

              for (var i = 0; i < res.data.data.length; i++) {
                  this.fab.push(false);
              }

          }).catch((error) => {

          });
      }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/OrderListComponent.vue